import { render, staticRenderFns } from "./SetCustomer.vue?vue&type=template&id=7ff2b964&scoped=true&"
import script from "./SetCustomer.vue?vue&type=script&lang=js&"
export * from "./SetCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SetCustomer.vue?vue&type=style&index=0&id=7ff2b964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff2b964",
  null
  
)

export default component.exports